import { Card } from "@/components/ui/card";
import { TrendingDown, Activity, AlertTriangle, LineChart } from "lucide-react";

function Kpi({ label, value, sub, icon: Icon, tone = "default", testid }) {
  const toneClasses =
    tone === "loss"
      ? "text-[#FF3B30]"
      : tone === "muted"
      ? "text-zinc-400"
      : "text-zinc-50";
  return (
    <Card
      data-testid={testid}
      className="bg-[#121214] border-white/10 rounded-md p-5 hover:border-white/20"
    >
      <div className="flex items-center justify-between text-zinc-500">
        <span className="text-[10px] font-mono uppercase tracking-[0.24em]">
          {label}
        </span>
        <Icon className="h-3.5 w-3.5" />
      </div>
      <div className={`mt-3 text-4xl font-mono font-medium tracking-tight ${toneClasses}`}>
        {value}
      </div>
      {sub && (
        <div className="mt-2 text-xs font-mono text-zinc-500 truncate">{sub}</div>
      )}
    </Card>
  );
}

export default function KpiCards({ snapshot, isLoading }) {
  if (isLoading || !snapshot) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="h-28 rounded-md bg-zinc-900/60 animate-pulse" />
        ))}
      </div>
    );
  }

  const losers = snapshot.losers || [];
  const count = losers.length;
  const biggest = losers[0];
  const avg =
    count > 0
      ? (losers.reduce((s, l) => s + l.change_pct, 0) / count).toFixed(2)
      : "—";

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <Kpi
        testid="kpi-total-losers"
        label="Total Losers ≥−10%"
        value={count}
        sub={`out of ${snapshot.scanned_count} scanned`}
        icon={AlertTriangle}
        tone={count > 0 ? "loss" : "default"}
      />
      <Kpi
        testid="kpi-biggest-loser"
        label="Biggest Loser"
        value={biggest ? `${biggest.change_pct.toFixed(2)}%` : "—"}
        sub={biggest ? `${biggest.ticker} · ${biggest.company_name || ""}` : "No stocks below threshold"}
        icon={TrendingDown}
        tone="loss"
      />
      <Kpi
        testid="kpi-avg-drop"
        label="Average Drop"
        value={count > 0 ? `${avg}%` : "—"}
        sub={count > 0 ? "across all losers" : "—"}
        icon={LineChart}
        tone={count > 0 ? "loss" : "default"}
      />
      <Kpi
        testid="kpi-session"
        label="Session"
        value={snapshot.date}
        sub={`${snapshot.universe_size} tickers in universe`}
        icon={Activity}
      />
    </div>
  );
}
